'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useCollapsibleContext } from './collapsible.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const CollapsibleSummaryButton = renderWithRef('CollapsibleSummaryButton', null, (o, i)=>{
    let { expanded: p, onRequestExpandedChange: l, contentId: s, disabled: a, headingLevel: u } = useCollapsibleContext(), b = _object_spread_props(_object_spread({}, o), {
        'aria-expanded': p,
        'aria-controls': null != s ? s : void 0
    });
    return a || (b.onClick = composeEventHandlersUtil(o.onClick, ()=>l(!p))), jsx(null != u ? u : Fragment, {
        children: jsx(RenderComp, {
            root: "button",
            forwardedRef: i,
            classNames: [
                'swan-collapsible-summary-button'
            ],
            props: b,
            children: o.children
        })
    });
});

export { CollapsibleSummaryButton };
